import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Table, Pagination, Row, Col, Space } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Loading, Page, Panel, Total } from '../../../../../../../components'
import { BreadcrumbSystem as Breadcrumb, SysPermission } from '../../../../../../../constants'
import { platformAdminRoleService } from '../../../../../../../services'
import { auth, validator } from '../../../../../../../util'
import { SysStore } from '../../../../../../../stores'

import 'antd/dist/antd.css'
import './styles.css'

const pageSize = 20

const columns = (platformId) => ([
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 6
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 9
  },
  {
    title: 'Organisation',
    dataIndex: 'org_name',
    key: 'org_name',
    width: 6
  },
  {
    width: 1,
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    render: (active) => active === true
      ? <CheckCircleOutlined style={{color: '#4fbc85', fontSize: '14pt'}} />
      : <CloseCircleOutlined style={{color: '#ccc', fontSize: '14pt'}} />
  },
  {
    width: 2,
    render: (item) => <Space size='middle'>
      { hasAccess(SysPermission.SOFTWARE.ADMIN_ROLES.UPDATE)
        ? <Link to={`/softwares/listing/${platformId}/roles/${item.id}`} key={`rolekey${item.id}`}>
          <FormOutlined />
        </Link>
        : null }

    </Space>
  },
])

const hasAccess = (permission) => {
  return auth.hasAccess(permission)
}

function SoftwareAdminRoleList (props) {
  const platformId = props.platformId
  const [isLoading, setIsLoading] = useState(false)
  const [list, setList] = useState([])
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({ active: true })
  const [sort, setSort] = useState({})

  useEffect(() => {
    fetchList({ currentPage: 1 })
  }, [])

  async function fetchList ({ currentPage = page }) {
    if (!hasAccess(SysPermission.SOFTWARE.ADMIN_ROLES.LIST)) return

    setIsLoading(true)
    filter.platform_id = platformId

    const r = await platformAdminRoleService.listByPage(currentPage, pageSize, filter, sort)
    if (r && r.list) {
      setIsLoading(false)
      setList(r.list)
      setPage(currentPage)
      setTotal(r.total)
    }
  }

  return (
    <div>
      <Page.Header title='User Roles'>
        { hasAccess(SysPermission.SOFTWARE.ADMIN_ROLES.CREATE)
          ? <Link to={`/softwares/listing/${platformId}/roles/add`}>
            <Button shape='round' type='primary'>Add User Role</Button>
          </Link>
          : null }
      </Page.Header>

      <Page.Content>
        <Table
          loading={isLoading}
          columns={columns(platformId)}
          dataSource={list}
          size='small'
          rowKey={(itm) => (`rolels${itm.id}`)}
          pagination={{
            hideOnSinglePage: true,
            pageSize,
            total,
            onChange: (e) => fetchList({currentPage: e})
          }}
        />
        <Total total={total} title={'role'} />
      </Page.Content>
    </div>
  )
}

export default SoftwareAdminRoleList
